<section class="expandable-card" [class.is-collapsed]="!isExpanded()">
  <div class="expandable-card-header" [class.expanded-header]="isExpanded()">
    <h2 class="expandable-card-header-title">
      {{ title() }}
    </h2>

    <div class="expandable-card-header-right-section">
      @if (!isExpanded()) {
        <ng-content select="[summary-wrapper]" />
      }
      <button
        type="button"
        class="expandable-card-expand-button"
        (click)="toggleExpanded()"
        [attr.aria-expanded]="isExpanded()"
        [attr.aria-label]="isExpanded() ? 'Collapse section' : 'Expand section'"
      >
        <mat-icon class="expandable-card-expand-icon material-icons-outlined">
          {{ isExpanded() ? "expand_less" : "expand_more" }}
        </mat-icon>
      </button>
    </div>
  </div>

  @if (isExpanded()) {
    <div
      class="expandable-card-content"
      [class.white-background]="whiteBackground()"
    >
      <ng-content />
    </div>
  }
</section>
